import { Component, inject, OnInit } from '@angular/core';
import { TranslocoDirective, TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  ButtonComponent,
  FormSectionComponent,
  TextFieldWithErrorComponent
} from 'htx-ui-library';
import { ProtectedContentComponent } from '../../../../organisms/protected-content/protected-content.component';
import { NavigationService } from '../../../../../services/navigation.service';
import { NotificationService } from '../../../../../services/form/notification.service';
import { FormErrorMessagesService } from '../../../../../services/form/form-error-messages.service';
import { DsaUserService } from '../../../../../services/dsa-users/dsa-user.service';
import { DsaUser } from '../../../../../services/dsa-users/dsa-user.model';

@Component({
  selector: 'app-dsa-user-add-page',
  imports: [
    TranslocoDirective,
    TranslocoPipe,
    ReactiveFormsModule,
    ButtonComponent,
    FormSectionComponent,
    TextFieldWithErrorComponent,
    ProtectedContentComponent
  ],
  templateUrl: './dsa-user-add-page.component.html',
  styleUrl: './dsa-user-add-page.component.scss'
})
export class DsaUserAddPageComponent implements OnInit {
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private dsaUserService = inject(DsaUserService);
  private notificationService = inject(NotificationService);
  private translocoService = inject(TranslocoService);
  private navigationService = inject(NavigationService);
  readonly errorMessagesService = inject(FormErrorMessagesService);

  requiredRoles = this.navigationService.getAccessRoles('admin/users');
  fieldLabels: { [key: string]: string } = {};
  saving = false;

  form = this.fb.group({
    firstName: ['', [Validators.required, Validators.maxLength(50)]],
    lastName: ['', [Validators.required, Validators.maxLength(50)]],
    email: ['', [Validators.required, Validators.email, Validators.maxLength(100)]]
  });

  ngOnInit(): void {
    const controlNames = ['firstName', 'lastName', 'email'];
    controlNames.forEach((name) => {
      this.fieldLabels[name] = this.translocoService.translate(
        `dsaManagement.users.form.${name}`
      );
    });
  }

  save(): void {
    if (this.form.invalid || this.saving) {
      return;
    }

    const value = this.form.getRawValue();
    const newUser: DsaUser = {
      firstName: value.firstName ?? '',
      lastName: value.lastName ?? '',
      email: value.email ?? ''
    };

    this.saving = true;
    this.dsaUserService.create(newUser).subscribe({
      next: () => {
        this.saving = false;
        this.notificationService.showSuccess('dsaManagement.users.saveSuccess', 5000);
        void this.router.navigate(['admin', 'users']);
      },
      error: () => {
        this.saving = false;
        this.notificationService.showError('dsaManagement.users.saveError', 5000);
      }
    });
  }

  cancel(): void {
    void this.router.navigate(['admin', 'users']);
  }
}
